import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints, calculateSpacing, colors } from '@vds-core/theme';
import { TypographyConfig, BodyConfig } from '@vds-core/typography';
var coreTypescale = TypographyConfig.getTypescale();
var propTypes = {
  /**
   * @ignore
   * Pass a Body typography configuration object
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   * Pass a supported Typescale
   */
  typescale: PropTypes.oneOf(['VDS', 'MVP', 'Marketing']),

  /**
   * @ignore
   * Padding styles for the ModalBody
   */
  padding: PropTypes.string,

  /**
   * @ignore
   * Function to calculate the typography to be used
   */
  calcTypography: PropTypes.func,

  /**
   * Children of this component will be rendered as the modal content.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};

function _calcTypography(bodyConfig, viewport, typescale) {
  var size = viewport === 'mobile' ? 'small' : 'medium';
  return bodyConfig.getStyles(typescale, viewport, size);
}

var defaultProps = {
  bodyConfig: BodyConfig,
  calcTypography: _calcTypography,
  padding: calculateSpacing('4X'),
  typescale: coreTypescale
};
var StyledModalBody = /*#__PURE__*/styled.div.attrs({
  'data-testid': 'modal-body'
}).withConfig({
  displayName: "StyledModalBody",
  componentId: "sc-o9hn4k-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  color: ", ";\n  line-height: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n  padding: ", ";\n  position: relative;\n  &:active {\n    outline: none;\n  }\n\n  @media (min-width: ", ") {\n    line-height: ", ";\n    font-size: ", ";\n    font-family: ", ";\n  }\n"])), function (_ref) {
  var inverted = _ref.inverted;
  return inverted ? colors.white : colors.black;
}, function (_ref2) {
  var mobileType = _ref2.mobileType;
  return calculateRem(mobileType.lineHeight);
}, function (_ref3) {
  var mobileType = _ref3.mobileType;
  return calculateRem(mobileType.fontSize);
}, function (_ref4) {
  var mobileType = _ref4.mobileType;
  return mobileType.fontFamily;
}, function (_ref5) {
  var desktopType = _ref5.desktopType;
  return desktopType && desktopType.letterSpacing ? calculateRem(desktopType.letterSpacing) : 0;
}, function (_ref6) {
  var padding = _ref6.padding;
  return padding;
}, breakpoints.md, function (_ref7) {
  var desktopType = _ref7.desktopType;
  return calculateRem(desktopType.lineHeight);
}, function (_ref8) {
  var desktopType = _ref8.desktopType;
  return calculateRem(desktopType.fontSize);
}, function (_ref9) {
  var desktopType = _ref9.desktopType;
  return desktopType.fontFamily;
});
/**
 * @ignore
 */

var ModalBody = function ModalBody(props) {
  var bodyConfig = props.bodyConfig,
      typescale = props.typescale,
      padding = props.padding,
      calcTypography = props.calcTypography;
  var desktopType = calcTypography(bodyConfig, 'desktop', typescale);
  var mobileType = calcTypography(bodyConfig, 'mobile', typescale);
  return /*#__PURE__*/React.createElement(StyledModalBody, _extends({
    desktopType: desktopType,
    mobileType: mobileType,
    padding: padding
  }, props));
};

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;
export default ModalBody;